import { localization } from '~/i18n';
import { enqueueSnackbar } from '~/utils/notifications';

/**
 * Warns that a selected location could not be brought into view. The message
 * names no series, so it carries no patient data.
 */
export function warnWhenLocationNotShown(isShown: boolean): void {
    if (!isShown) {
        enqueueSnackbar(localization.t('viewport.locate.notShown'), {
            variant: 'warning',
        });
    }
}
